

<div [className]="'login_Login'">
  <form class="form-signin text-center" (ngSubmit)="login()">
    <div>

      @if (isJTGO) {
        <img class="mb-4" src="assets/images/JT-GO-Master-Logo-RGB.png" alt="Jobtrain Login" width="200">
      } @else {
        <img class="mb-4" src="assets/images/JT_signin_Logo.gif" alt="Jobtrain Login" width="200" data-testid="img-default-logo">
      }


    </div>
    <div #container></div>
    <!--<h1 class="h3 mb-3 font-weight-normal">{{ 'Login.SecureLogin' | translate }}</h1>-->

    <span id="MainContent_diverror" class="error-message">{{this.authService.error | translate}}</span>
    @if (isIEBrowser || isOlderEdgeBrowser) {
      <div class="ie-warning-message" [innerHTML]="'Login.UnSupportedBrowserMessage' | translate">
      </div>
    }
    <label for="inputEmail" class="sr-only">{{ 'Login.EmailaddressSr' | translate }}</label>
    <input type="text" id="inputEmail" data-testid="txt-email" class="form-control" placeholder="{{ 'Login.UserName' | translate }}" #userName="ngModel" name="userName" asp-for="Username" [(ngModel)]="user.userName" required autofocus>
    <label for="inputPassword" class="sr-only">{{ 'Login.PasswordSr' | translate }}</label>
    <app-password-input [(ngModel)]="user.password"
      name="password"
      id="inputPassword"
      required
      [placeholder]="'Login.Password' | translate"
      data-test-id="txt-password"
      className="password-icon">
    </app-password-input>
    <!--<input type="password" id="inputPassword" data-testid="txt-password" class="form-control" placeholder="{{ 'Login.Password' | translate }}" #password="ngModel" name="password" asp-for="Password" [(ngModel)]="user.password" required>-->
    <button class="btn btn-lg btn-primary btn-block btn_login" data-testid="btn-login" type="submit">{{ 'Login.Login' | translate }}</button>
    <div style="width:100%">
      @if (ssoConfig && ssoConfig.SingleSignOn === 'Yes') {
        <div class="sso-login">
          @if (ssoConfig !==null && ssoConfig.SingleSignOn_Type === 'Microsoft' && ssoConfig.ForceSingleSignIn_Microsoft === 'Y') {
            <a class="text-left pull-left mt-2" href="#" (click)="SSOLogin()">{{ 'Login.SSOLogin' | translate }}</a>
          }
          @if (ssoConfig !==null && ssoConfig.SingleSignOn_Type === 'Cas') {
            <button class="btn btn-lg btn-cas-login btn-block btn_cas_login mt-2" href="#" (click)="CASLogin()">{{'Login.CasLogin' | translate}}</button>
          }
          @if (ssoConfig !==null && ssoConfig.SingleSignOn_Type === 'Okta') {
            <button class="btn btn-lg btn-cas-login btn-block btn_cas_login mt-2" href="#" (click)="OktaLogin()">{{'Login.OktaLogin' | translate}}</button>
          }
        </div>
      }

      <a class="f_password pull-right mt-2" href="#" data-testid="a-redirect-to-forgot-password" (click)="redirectToUrl()">{{ 'Login.ForgotPassword' | translate }}</a>
      @if (showMobileLink) {
        <br />
        <p class="text-center mt-5 mobilelink">@if (showMobileLink) {
          <a href="#" data-testid="p-goto-mobile-version" (click)="goToMobile()">{{ 'Login.GoToMobileVersion' | translate }}</a>
        }</p>
      }

    </div>
    <br />
    <!--<p class="mt-2 text-muted">If you have forgotten your username, or are unsure if you have an account, please contact your HR/IT System Administrator</p>-->
    <p class="text-muted" data-testid="p-copyright" [ngClass]="{'resetParagraphMargin': showMobileLink}">&copy; {{ copyRight }}</p>
    @if (loginMessage !== '' && loginMessage !== null) {
      <div class="login-info-message" [innerHTML]="loginMessage">
      </div>
    }
  </form>
</div>

